import React from 'react'
import Layout from '../../components/Layout'
import H1 from '../../components/H1'

export default function Page() {
  return (
    <Layout>
      <H1 title="Jobs" />
        {/* <p>
          No jobs listed at this time.
          The following positions are currently open to qualified seekers.
        </p> */}
        <ul>
        <li>
          <a target="_blank" rel="noopener" href="https://careers.ua.edu/jobs/institutional-research-analyst-i-530684-tuscaloosa-alabama-united-states">
          University of Alabama - Institutional Research Analyst I
          </a>
          <p>
            The Office of Institutional Research and Assessment at The University of Alabama is currently seeking applicants for an Institutional Research Analyst I position.
          </p>
          <p>
            This position will provide analytical and informational support for University planning, operations, and decision-making, while also supporting a variety of federal, state, System, reputational, and institutional reporting efforts.
          </p>
          <p>
            We are looking for someone with strong analytical, organizational, and communication skills who is comfortable working with data and collaborating with a variety of campus partners.
          </p>
        </li>
        {/* <li>
          <a target="_blank" rel="noopener" href="https://jobs.auburn.edu/auburn-careers-home/jobs/8661?lang=en-us">
          Auburn University - Analyst, Institutional Studies
          </a>
          <p>
            The Office of Institutional Research is looking for an Analyst to provide demographic, analytical and other information about the University, its programs and its student population and assists in developing and maintaining data systems to support their analysis.
          </p>
        </li> */}
        </ul>
    </Layout>
  )
}
